var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 94.47298,
    x2: 94.47298,
    y1: 175.992366,
    y2: 289.294316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#393536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393536",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    transform: "matrix(.09697275 0 0 .16291879 .846353 -15.13148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.703733 289.29431h4.45946l-8.01052-17.18303-4.51591-.22864v10.90898l6.09917.82766z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.636763 175.99238v2.26695l6.09917.82762 6.70455 19.33645-8.28781-17.77788-4.51591-.22895v10.9093l6.09917.82761 6.70455 19.33646-8.28781-17.77788-4.51591-.22896v10.9093l6.09917.82762 6.70455 19.33646-8.28781-17.77789-4.51591-.2286v10.90895l6.09917.82762 6.70455 19.33645-8.28781-17.77788-4.51591-.2286v10.90895l6.09917.82761 6.70455 19.33646-8.28781-17.77788-4.51591-.2286v10.90894l6.09917.82762 6.70455 19.33646-8.28781-17.77789-4.51591-.2286v10.90895l6.09917.82762 6.70455 19.33645-8.28781-17.77788-4.51591-.2286v10.90891l6.09917.82765 6.49817 18.74161h3.75849v-113.30193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.152673 285.17781-4.51591-.2286v4.3451h6.43502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.49926 289.29431h-4.45946l8.01052-17.18303 4.51591-.22864v10.90898l-6.09918.82766z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.56623 175.99238v2.26695l-6.09918.82762-6.70454 19.33645 8.28781-17.77788 4.51591-.22895v10.9093l-6.09918.82761-6.70454 19.33646 8.28781-17.77788 4.51591-.22896v10.9093l-6.09918.82762-6.70454 19.33646 8.28781-17.77789 4.51591-.2286v10.90895l-6.09918.82762-6.70454 19.33645 8.28781-17.77788 4.51591-.2286v10.90895l-6.09918.82761-6.70454 19.33646 8.28781-17.77788 4.51591-.2286v10.90894l-6.09918.82762-6.70454 19.33646 8.28781-17.77789 4.51591-.2286v10.90895l-6.09918.82762-6.70454 19.33645 8.28781-17.77788 4.51591-.2286v10.90891l-6.09918.82765-6.49816 18.74161h-3.7585v-113.30193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.05032 285.17781 4.51591-.2286v4.3451h-6.43502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.73001 289.29431h-13.257027v-113.30193h13.257027z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    transform: "matrix(.09697275 0 0 .16291879 11.884556 -15.13148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.703733 289.29431h4.45946l-8.01052-17.18303-4.51591-.22864v10.90898l6.09917.82766z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.636763 175.99238v2.26695l6.09917.82762 6.70455 19.33645-8.28781-17.77788-4.51591-.22895v10.9093l6.09917.82761 6.70455 19.33646-8.28781-17.77788-4.51591-.22896v10.9093l6.09917.82762 6.70455 19.33646-8.28781-17.77789-4.51591-.2286v10.90895l6.09917.82762 6.70455 19.33645-8.28781-17.77788-4.51591-.2286v10.90895l6.09917.82761 6.70455 19.33646-8.28781-17.77788-4.51591-.2286v10.90894l6.09917.82762 6.70455 19.33646-8.28781-17.77789-4.51591-.2286v10.90895l6.09917.82762 6.70455 19.33645-8.28781-17.77788-4.51591-.2286v10.90891l6.09917.82765 6.49817 18.74161h3.75849v-113.30193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.152673 285.17781-4.51591-.2286v4.3451h6.43502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.49926 289.29431h-4.45946l8.01052-17.18303 4.51591-.22864v10.90898l-6.09918.82766z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.56623 175.99238v2.26695l-6.09918.82762-6.70454 19.33645 8.28781-17.77788 4.51591-.22895v10.9093l-6.09918.82761-6.70454 19.33646 8.28781-17.77788 4.51591-.22896v10.9093l-6.09918.82762-6.70454 19.33646 8.28781-17.77789 4.51591-.2286v10.90895l-6.09918.82762-6.70454 19.33645 8.28781-17.77788 4.51591-.2286v10.90895l-6.09918.82761-6.70454 19.33646 8.28781-17.77788 4.51591-.2286v10.90894l-6.09918.82762-6.70454 19.33646 8.28781-17.77789 4.51591-.2286v10.90895l-6.09918.82762-6.70454 19.33645 8.28781-17.77788 4.51591-.2286v10.90891l-6.09918.82765-6.49816 18.74161h-3.7585v-113.30193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.05032 285.17781 4.51591-.2286v4.3451h-6.43502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.73001 289.29431h-13.257027v-113.30193h13.257027z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusShadow);
export default __webpack_public_path__ + "static/media/bus-shadow.4513c85310686e4727f68c7b72fcd06d.svg";
export { ForwardRef as ReactComponent };